/**
 * Main page implementation.
 *
 * @author Stanislav Kalashnik <sk@infomir.eu>
 * @license GNU GENERAL PUBLIC LICENSE Version 3
 */

'use strict';

var id   = 'pageMain',
    Page = require('stb-component-page'),
    page = new Page({$node: document.getElementById(id)}),
    $text = document.getElementById('input'),
    hideTimeout,
    HIDE_INTERVAL = 1500,
    value,
    currentIntent;


function hideWidget () {
    currentIntent.emit('done', value);
    currentIntent.close();
}


function inputNumber ( val ) {
    if ( value.length < 4 ) {
        $text.innerText += val;
        value += val;
    }
    clearTimeout(hideTimeout);
    hideTimeout = setTimeout(hideWidget, HIDE_INTERVAL);
}

core.addListener('intent', function ( intent, done ) {
    currentIntent = intent;
    intent.once('close', function () {
        core.call('hide');
        core.call('blur');
    });
    $text.innerText = '';
    value = intent.data.startChar;
    $text.innerText = intent.data.startChar;
    core.call('show');
    core.call('focus');
    clearTimeout(hideTimeout);
    hideTimeout = setTimeout(hideWidget, HIDE_INTERVAL);
    done(false, {});
});

debug.log('OSD-INPUT STARTED!!!!!!!!!!', 'blue');

page.addListener('keydown', function ( event ) {
    switch ( event.code ) {
        case 48:
        case 49:
        case 50:
        case 51:
        case 52:
        case 53:
        case 54:
        case 55:
        case 56:
        case 57:
            inputNumber(String.fromCharCode(event.code));
            break;
    }
});

// public
module.exports = page;
